export const facetAttributeValueReadable = (item: string): string =>
  item
    .toString()
    .replace(/^all$/i, '')
    .replace(/^prints$/i, 'Art Prints')
    .replace(/^open$/i, 'Open Editions')
    .replace(/^limited$/i, 'Limited Edtions')
    .replace(/^rag$/i, 'Fine Art Paper')
    .replace(/^canvas$/i, 'Canvas')
    .replace(/^photo$/i, 'Photo Paper')

export const createLinkTitle = ({
  hasPrints,
  breadcrumbFacets,
  index,
}: {
  hasPrints: boolean
  breadcrumbFacets: Array<string>
  index: number
}): string => {
  // Append `category` & `print` to end and join everything together
  // ['print', 'Photography', 'Documentary', 'Landscape', 'Digital']
  // Results => 'Documentary Landscape Digital Photography Art Prints'
  let printsTitle = ''
  let categoryTitle = ''
  const facetNames: string =
    breadcrumbFacets
      .slice(1, index + 1)
      .filter(Boolean)
      .join(' ') || ''

  if (hasPrints) {
    printsTitle =
      breadcrumbFacets
        .slice(0, 1)
        .filter(Boolean)
        .join('') || ''
    categoryTitle =
      breadcrumbFacets
        .slice(1, 1)
        .filter(Boolean)
        .join('') || ''
  } else {
    printsTitle = ''
    categoryTitle = breadcrumbFacets
      .slice(0, 1)
      .filter(Boolean)
      .join('')
  }

  const titleItems: Array<string> = [facetNames, printsTitle, categoryTitle]
    .filter(Boolean)
    .map(facetAttributeValueReadable)
  return titleItems.join(' ')
}
